import { combineReducers } from 'redux';
import { reducer as form } from 'redux-form';
import transactions from './transactionsReducer';
import rules from './rulesReducer';
import matchables from './matchablesReducer';
import status from './statusReducer';
import xpa from './xpaReducer';
import rah from './rahReducer';
import bankfeeds from './bankfeedsReducer';
import comments from './commentsReducer';
import { reducer as notifications} from 'react-notification-system-redux';

export default combineReducers({
  xpa,
  rah,
  form,
  rules,
  matchables,
  status,
  transactions,
  bankfeeds,
  notifications,
  comments
});


// WEBPACK FOOTER //
// ./src/reducers/index.js